
import API from '../../services/client'

export default async (session_uuid, session)=>{
        try{
                return await API.CatalogueManager.sessions.update(session_uuid, session)
        }catch(err){
                return err
        }
}